// Constantes y helpers de la capa de Hechos (ClientFact). Espejan el modelo del backend
// (core/models/marketing/client_fact.py). Los labels salen por i18n (claves abajo).

export const REVIEW_STATUS = {
    PENDING: 'PENDING_REVIEW',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};

export const VISIBILITY = {
    AGENCY_ONLY: 'AGENCY_ONLY',
    SHARED: 'SHARED',
};

export const ORIGIN = {
    CLIENT_ASSERTED: 'CLIENT_ASSERTED',
    AI_INFERRED: 'AI_INFERRED',
};

export const CONFIDENCE = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
};

// Orden de tipos para agrupar la biblioteca: riesgo y restricciones primero (espeja la
// priorización del retriever del backend — un hecho de churn o un límite no se entierran).
export const FACT_TYPE_ORDER = [
    'RISK', 'CONSTRAINT', 'OBJECTIVE', 'COMMITMENT', 'BACKGROUND',
    'DECISION', 'STAKEHOLDER', 'PREFERENCE', 'LEARNING', 'COMMERCIAL', 'OTHER',
];

// Tipos sensibles: nunca se comparten con el cliente (RISK/COMMERCIAL). El toggle SHARED
// se deshabilita para estos.
export const SENSITIVE_TYPES = ['RISK', 'COMMERCIAL'];

export const isSensitive = (fact) => SENSITIVE_TYPES.includes(fact && fact.fact_type);

// Modificadores CSS por tipo (color del acento de la fila). Definidos en _client-memory.scss.
export const FACT_TYPE_MODIFIER = {
    RISK: '-risk',
    CONSTRAINT: '-constraint',
    OBJECTIVE: '-objective',
    COMMITMENT: '-commitment',
    BACKGROUND: '-background',
    DECISION: '-decision',
    STAKEHOLDER: '-stakeholder',
    PREFERENCE: '-preference',
    LEARNING: '-learning',
    COMMERCIAL: '-commercial',
    OTHER: '-other',
};

export const CONFIDENCE_MODIFIER = {
    HIGH: '-high',
    MEDIUM: '-medium',
    LOW: '-low',
};

// --- Triage de durabilidad (Etapa A) ---
// Un hecho degradado por el triage viene con review_priority=LOW y una durability_class de ruido
// (espeja document_extraction_service.DURABILITY_NOISE_CATEGORIES del backend). La cola separa
// esos ("Ruido probable", agrupado + descarte por familia) de los que el gate mandó a revisión
// por sensibilidad/confianza ("Por revisar"). Con el triage apagado nadie es LOW → la sección de
// ruido queda vacía (degradación limpia, la cola se comporta como antes).
export const REVIEW_PRIORITY = {LOW: 'LOW'};

export const isLowPriority = (fact) => !!fact && fact.review_priority === REVIEW_PRIORITY.LOW;

// Orden de las familias de ruido en la cola (aprox. por frecuencia esperada, del análisis del golden).
export const DURABILITY_NOISE_ORDER = [
    'MEETING_LOGISTICS', 'AGENCY_INTERNAL', 'TACTICAL',
    'EPHEMERAL_METRIC', 'COMMERCIAL_RELATIONSHIP', 'CHATTER_OR_OTHER_CLIENT',
];

// --- Nivel de detalle (2da dimensión del clasificador, ortogonal a la durabilidad) ---
// GLOBAL = negocio/estrategia/relación; PLATFORM = config/táctica específica de una plataforma.
// Es un tag de VISTA (filtro/orden para que un no-especialista no se maree): null (hechos viejos
// o manuales, sin backfill) cuenta como GLOBAL — la vista default no esconde nada.
export const DETAIL_LEVEL = {GLOBAL: 'GLOBAL', PLATFORM: 'PLATFORM'};

export const effectiveDetailLevel = (fact) => (
    fact && fact.detail_level === DETAIL_LEVEL.PLATFORM ? DETAIL_LEVEL.PLATFORM : DETAIL_LEVEL.GLOBAL);

// Claves i18n (namespace client_memory.*).
export const factTypeLabelKey = (type) => `client_memory.fact_type.${(type || 'OTHER').toLowerCase()}`;
// Definición del tipo, para explicarlo donde se muestra (`FactTypeHelp`). Resume el bloque «TIPOS»
// del prompt del extractor: los dos se editan juntos o el texto de pantalla queda mintiendo.
export const factTypeDescKey = (type) => `client_memory.fact_type_desc.${(type || 'OTHER').toLowerCase()}`;
export const confidenceLabelKey = (c) => `client_memory.confidence.${(c || 'LOW').toLowerCase()}`;
export const originLabelKey = (o) => `client_memory.origin.${(o || 'AI_INFERRED').toLowerCase()}`;
export const durabilityLabelKey = (c) => `client_memory.durability.${(c || 'OTHER').toLowerCase()}`;
